var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTermAdd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 10,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1D1D1D",
  d: "M5.5 9.666a.64.64 0 0 1-.475-.192A.64.64 0 0 1 4.833 9V5.666H1.5a.65.65 0 0 1-.475-.192A.65.65 0 0 1 .833 5q0-.284.192-.476a.65.65 0 0 1 .475-.191h3.333V1q0-.284.192-.476A.65.65 0 0 1 5.5.333q.283 0 .475.191A.65.65 0 0 1 6.167 1v3.333H9.5q.283 0 .475.191a.65.65 0 0 1 .192.476.64.64 0 0 1-.192.474.64.64 0 0 1-.475.192H6.167V9a.65.65 0 0 1-.192.474.65.65 0 0 1-.475.192"
})));
export default SvgTermAdd;